export default __webpack_public_path__ + "static/media/cv.a5b6c4d9.svg";